export const enum RectTablePropertiesEnum {
  SelectionType = "selectionType",
  Category = "category",

  SeatsQuantityLeft = "seatsQuantityLeft",
  SeatsQuantityRight = "seatsQuantityRight",
  SeatsQuantityUp = "seatsQuantityUp",
  SeatsQuantityDown = "seatsQuantityDown",

  TableWidth = "tableWidth",
  TableHeight = "tableHeight",

  SectionLabel = "sectionLabel",

  TableLabelingVisible = "tableLabelingVisible",
  TableLabelingLabel = "tableLabelingÑabel",
  TableLabelingDisplayedLabel = "tableLabelingDisplayedLabel",

  SeatLabelingType = "seatLabelingType",
  SeatLabelingStartsAt = "seatLabelingStartsAt"
}